module.exports = __webpack_public_path__ + "img/logo.4380d36f.jpg";